import { useState } from "react";
import { Link } from "react-router-dom";
import {API_URL} from "../constants"
const ContactForm = () => {
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formdata = new FormData(e.target);
    const data = Object.fromEntries(formdata);

    // Check if all required fields are filled
    const requiredFields = [
      "first_name",
      "last_name",
      "company",
      "company_size",
      "email",
      "referral",
      "comments",
    ];
    const isPrivacyChecked = e.target.agree.checked;

    const isValid = requiredFields.every((field) => data[field].trim() !== "");
    if (!isValid) {
      alert("Please fill in all required fields.");
      return;
    }

    if (!isPrivacyChecked) {
      alert("You must agree to the Privacy Policy.");
      return;
    }

    setStatus("loading");

    try {
      const response = await fetch(API_URL+"general/contact/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      console.log(response.data)
      if (response.ok) {
        setStatus("success");
        e.target.reset(); // Clear form
      } else {
        setStatus("error");
      }
    } catch (error) {
      setStatus("error");
    }
  };

  return (
    <section className="p-10 text-center bg-[#102742] text-white rounded-xl max-w-2xl mx-auto">
      <h2 className="text-4xl font-bold pb-3">
        Get in <span className="text-[#19BFB7] ">Touch</span>
      </h2>
      <p className="text-sm text-gray-400">
        Our friendly team would love to hear from you
      </p>

      {status === "success" && (
        <p className="text-green-500 mb-4">Message sent successfully!</p>
      )}
      {status === "error" && (
        <p className="text-red-500 mb-4">Something went wrong. Try again.</p>
      )}

      <form onSubmit={handleSubmit} className="mt-6 space-y-4 text-left">
        {/* First and Last Name */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label htmlFor="fname" className="block mb-1 text-[#19BFB7]">
              First name *
            </label>
            <input
              id="fname"
              name="first_name"
              type="text"
              placeholder="First name"
              required
              className="w-full p-3 border rounded bg-[#112D4E] text-white placeholder-gray-400 border-[#1f528e]"
            />
          </div>
          <div>
            <label htmlFor="lname" className="block mb-1 text-[#19BFB7]">
              Last name *
            </label>
            <input
              id="lname"
              name="last_name"
              type="text"
              placeholder="Last name"
              required
              className="w-full p-3 border rounded bg-[#112D4E] text-white placeholder-gray-400 border-[#1f528e]"
            />
          </div>
        </div>

        {/* Company Name */}
        <div>
          <label htmlFor="company" className="block mb-1 text-[#19BFB7]">
            Company Name *
          </label>
          <input
            id="company"
            name="company"
            type="text"
            placeholder="e.g. Tesla"
            required
            className="w-full p-3 border rounded bg-[#112D4E] text-white placeholder-gray-400 border-[#1f528e]"
          />
        </div>

        {/* Company Size */}
        <div>
          <label htmlFor="company-size" className="block mb-1 text-[#19BFB7]">
            Company Size *
          </label>
          <select
            id="company-size"
            name="company_size"
            required
            className="w-full p-3 border rounded bg-[#112D4E] text-white placeholder-gray-400 border-[#1f528e]"
            defaultValue=""
          >
            <option value="" disabled>
              Please select
            </option>
            <option value="small">1-10 employees</option>
            <option value="medium">11-50 employees</option>
            <option value="large">51-200 employees</option>
            <option value="enterprise">201+ employees</option>
          </select>
        </div>

        {/* Work Email */}
        <div>
          <label htmlFor="email" className="block mb-1 text-[#19BFB7]">
            Work Email *
          </label>
          <input
            id="Email"
            name="email"
            type="email"
            placeholder="you@company.com"
            required
            className="w-full p-3 border rounded bg-[#112D4E] text-white placeholder-gray-400 border-[#1f528e]"
          />
        </div>

        {/* Phone Number */}
        <div>
          <label htmlFor="phone" className="block mb-1 text-[#19BFB7]">
            Phone number
          </label>
          <input
            id="phone"
            name="Phone"
            type="tel"
            placeholder="+1 (555) 000-0000"
            className="w-full p-3 border rounded bg-[#112D4E] text-white placeholder-gray-400 border-[#1f528e]"
          />
        </div>

        {/* How did you hear about us? */}
        <div>
          <label htmlFor="referral" className="block mb-1 text-[#19BFB7]">
            How did you hear about us? *
          </label>
          <input
            id="referral"
            name="referral"
            type="text"
            placeholder="Google, Social Media, etc."
            required
            className="w-full p-3 border rounded bg-[#112D4E] text-white placeholder-gray-400 border-[#1f528e]"
          />
        </div>

        {/* Comments */}
        <div>
          <label htmlFor="comments" className="block mb-1 text-[#19BFB7]">
            Any comments *
          </label>
          <textarea
            id="comments"
            name="comments"
            placeholder="Leave us a message..."
            required
            className="w-full p-3 border rounded bg-[#112D4E] text-white placeholder-gray-400 border-[#1f528e]"
            rows="4"
          ></textarea>
        </div>

        {/* Checkbox for Privacy Policy */}
        <div className="flex items-center space-x-2">
          <input
            id="agree"
            name="agree"
            type="checkbox"
            className="form-checkbox text-[#19BFB7] bg-[#112D4E] border-[#1f528e] rounded focus:ring-0"
          />
          <label htmlFor="agree" className="text-sm text-gray-300">
            You agree to our friendly{" "}
            <Link to="/privacypolicy" className="text-[#19BFB7] hover:underline">
              Privacy Policy
            </Link>
          </label>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="bg-[#19BFB7] text-white px-6 py-2 rounded w-full hover:bg-[#17a19a] transition duration-300"
          disabled={status === "loading"}
        >
          {status === "loading" ? "Sending..." : "Send Message"}
        </button>
      </form>
    </section>
  );
};

export default ContactForm;
